/* Maison du Booster : extrait de mdb-design-bloc.liquid (23/09, charge en defer) */
  (function () {
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* description de la fiche : chaque titre h2 devient une section depliable (la premiere ouverte) */
    function sectionsDescription() {
      document.querySelectorAll('.product-details .text-block.rte').forEach(function (bloc) {
        if (bloc.dataset.mdbSections || !bloc.querySelector(':scope > h2')) return;
        bloc.dataset.mdbSections = '1';
        var enfants = Array.prototype.slice.call(bloc.children), conteneur = document.createElement('div'), courant = null, n = 0;
        /* 06/10 : la section « Dans la boite » (tuiles) liste deja le contenu : l'accordeon « Contenu » ferait doublon */
        var boite = !!document.querySelector('.mdb-boite'), saute = false;
        conteneur.className = 'mdb-sections';
        enfants.forEach(function (el) {
          if (el.tagName === 'H2' && boite && el.textContent.trim().toLowerCase() === 'contenu') { saute = true; courant = null; el.remove(); return; }
          if (saute && el.tagName !== 'H2') { if (el.tagName === 'UL' || el.tagName === 'OL') el.remove(); return; }
          saute = false;
          if (el.tagName === 'H2') {
            courant = document.createElement('details');
            if (n === 0 && !boite) courant.open = true;
            n++;
            var s = document.createElement('summary');
            s.textContent = el.textContent;
            courant.appendChild(s);
            courant.appendChild(document.createElement('div'));
            conteneur.appendChild(courant);
            el.remove();
          } else if (courant) {
            courant.lastChild.appendChild(el);
          }
        });
        if (n) bloc.appendChild(conteneur);
      });
    }

    /* 06/10 : « Vous aimerez aussi » sans les produits deja proposes dans « Pour proteger vos cartes » (.mdb-acc) ;
       s'il en reste moins de 2, le bloc est masque (une carte seule sur 4 colonnes).
       Horizon ne remplit ce bloc qu'a l'approche : il reservait ~590 px vides puis se repliait sous les yeux. La decision
       est donc prise TOT, par une petite requete JSON, pendant que le bloc est encore loin sous l'ecran.
       Relecture du 06/10 : si Shopify ne recommande RIEN, Horizon affiche 4 produits du catalogue : on ne masque pas.
       Si la requete echoue, nettoyer() compte ce qui reste et sert de filet. On ne vise que la section du bas
       (enfant direct de sa section), jamais un bloc pose dans la colonne de la fiche. Rien dans l'editeur de theme. */
    function recommandations() {
      if (window.Shopify && window.Shopify.designMode) return;
      var rec = document.querySelector('.shopify-section > product-recommendations');
      if (!rec) return;
      var zone = rec.parentElement, deja = {};
      function poignee(a) { return ((a.getAttribute('href') || '').split('?')[0].split('/products/')[1] || '').replace(/\/$/, ''); }
      document.querySelectorAll('.mdb-acc a[href*="/products/"]').forEach(function (a) { deja[poignee(a)] = 1; });
      function nettoyer() {
        var items = zone.querySelectorAll('product-recommendations .resource-list__item'), n = 0;
        items.forEach(function (it) {
          var a = it.querySelector('a[href*="/products/"]');
          if (a && deja[poignee(a)]) it.remove(); else n++;
        });
        if (items.length && n < 2) zone.style.display = 'none';
      }
      var id = rec.getAttribute('data-product-id');
      if (id && window.fetch) {
        var limite = ((rec.getAttribute('data-url') || '').match(/limit=(\d+)/) || [0, 4])[1];
        var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(racine + 'recommendations/products.json?product_id=' + id + '&limit=' + limite + '&intent=' + (rec.getAttribute('data-intent') || 'related'))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (!d || !d.products || !d.products.length) return;
            var reste = d.products.filter(function (p) { return !deja[p.handle]; }).length;
            if (reste < 2) zone.style.display = 'none';
          })
          .catch(function () {});
      }
      nettoyer();
      if ('MutationObserver' in window) new MutationObserver(nettoyer).observe(zone, { childList: true, subtree: true });
    }

    /* estimation de livraison : expedition sous 2 a 3 jours ouvres + 1 a 3 jours de transport */
    function livraison() {
      var el = document.querySelector('[data-mdb-livraison] span');
      if (!el || !window.Intl) return;
      function ajouterOuvres(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; } return r; }
      var f = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
      var auj = new Date(), debut = ajouterOuvres(auj, 3), fin = ajouterOuvres(auj, 6);
      el.innerHTML = 'Livraison estimée entre le <strong>' + f.format(debut) + '</strong> et le <strong>' + f.format(fin) + '</strong>';
    }

    function animations() {
      if (reduit || !('IntersectionObserver' in window)) return;
      document.documentElement.classList.add('mdb-js');
      /* 23/09 (vitesse) : plus d'apparition progressive sur les grilles de produits (.mdb-product, .product-grid__card) :
         en defilement rapide les produits doivent etre la immediatement ; on la garde sur les sections decoratives */
      var cibles = '.mdb-jeu, .mdb-engage, .mdb-head, .mdb-bande .mdb-h2, .mdb-garanties > div, .mdb-cal__item, .mdb-faq details, .mdb-footer__col, .mdb-arr__item, .mdb-projet';
      var io = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px' });
      document.querySelectorAll(cibles).forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
        var i = Array.prototype.indexOf.call(el.parentElement.children, el);
        el.style.setProperty('--mdb-i', Math.min(i, 4));
        el.classList.add('mdb-reveal');
        io.observe(el);
      });
    }

    /* inclinaison 3D des cartes : une seule mise a jour par image (requestAnimationFrame), transition tres courte
       pendant le mouvement (classe mdb-suivi) pour coller a la souris */
    function inclinaison() {
      if (reduit) return;   /* souris seulement : teste a chaque mouvement (pointerType), pas une seule fois au chargement */
      var sel = '.mdb-product__link, .product-grid__card', courant = null, dernier = null, attente = false;
      function appliquer() {
        attente = false;
        var c = dernier && dernier.target.closest ? dernier.target.closest(sel) : null;
        if (c !== courant) {
          if (courant) courant.classList.remove('mdb-suivi');
          courant = c;
        }
        if (!c) return;
        var r = c.getBoundingClientRect(), x = (dernier.clientX - r.left) / r.width, y = (dernier.clientY - r.top) / r.height;
        c.classList.add('mdb-suivi');
        c.style.setProperty('--ry', ((x - 0.5) * 13).toFixed(2) + 'deg');
        c.style.setProperty('--rx', ((0.5 - y) * 13).toFixed(2) + 'deg');
        c.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        c.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      }
      document.addEventListener('pointermove', function (ev) {
        if (ev.pointerType === 'touch') return;
        dernier = ev;
        if (!attente) { attente = true; requestAnimationFrame(appliquer); }
      }, { passive: true });
    }

    /* menu ordinateur : indicateur qui glisse sous le lien survole */
    /* le theme reconstruit le menu apres le chargement : l'indicateur est donc cree (ou recree) au moment du survol, et les
       evenements sont ecoutes sur le document plutot que sur le menu */
    function suiveurMenu() {
      var nav = null, s = null, cible = null, attente = false;
      function preparer(n) {
        nav = n;
        s = n.querySelector(':scope > .mdb-nav-suiveur');
        if (!s) {
          s = document.createElement('span');
          s.className = 'mdb-nav-suiveur';
          s.setAttribute('aria-hidden', 'true');
          n.appendChild(s);
        }
      }
      function placer() {
        attente = false;
        if (!nav || !s) return;
        if (!cible) { s.classList.remove('is-on'); nav.classList.remove('mdb-nav-survol'); return; }
        var t = cible.querySelector('.menu-list__link-title');
        if (!t) return;
        /* repere = conteneur positionne reel de l'indicateur (le menu lui-meme n'est plus positionne) */
        var ref = s.offsetParent || nav, rn = ref.getBoundingClientRect(), rt = t.getBoundingClientRect(), cs = getComputedStyle(t);
        var pg = parseFloat(cs.paddingLeft) || 0, pd = parseFloat(cs.paddingRight) || 0;
        var x = rt.left - rn.left - ref.clientLeft + pg, w = Math.max(8, rt.width - pg - pd), y = rt.bottom - rn.top - ref.clientTop + 6;
        var apparition = !s.classList.contains('is-on');
        if (apparition) s.style.transition = 'opacity 0.18s ease';   /* 1re apparition : sur place, sans glisser */
        s.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) scaleX(' + (w / 100).toFixed(3) + ')';
        if (apparition) { s.getBoundingClientRect(); s.style.transition = ''; }
        s.classList.add('is-on');
        nav.classList.add('mdb-nav-survol');
      }
      function demander(li) { cible = li; if (!attente) { attente = true; requestAnimationFrame(placer); } }
      function navDe(el) { return el && el.closest ? el.closest('#header-component nav.menu-list') : null; }
      document.addEventListener('pointerover', function (e) {
        if (e.pointerType === 'touch') return;
        var n = navDe(e.target);
        if (!n) { if (cible) demander(null); return; }
        var li = e.target.closest('.menu-list__list-item');
        if (li && li.querySelector('.menu-list__link-title')) { if (n !== nav || !s || !n.contains(s)) preparer(n); demander(li); }
      }, { passive: true });
      document.addEventListener('pointerout', function (e) { if (!e.relatedTarget && cible) demander(null); }, { passive: true });
      document.addEventListener('focusin', function (e) {
        var n = navDe(e.target);
        if (!n) { if (cible) demander(null); return; }
        var li = e.target.closest('.menu-list__list-item');
        if (li && e.target.matches(':focus-visible')) { if (n !== nav || !s || !n.contains(s)) preparer(n); demander(li); }
      });
    }

    /* menu mobile : les images (dans les sous-menus Boutique / Accessoires) se chargent des qu'on touche ou survole le
       bouton menu, avant l'ouverture du sous-menu. Plus de chargement en tache de fond sur chaque page (vitesse, 23/09) :
       13 images (~400 Ko) qui concurrencaient les photos de la page sur mobile. */
    function prechargementMenu() {
      var fait = false;
      function charger() {
        if (fait) return;
        fait = true;
        document.querySelectorAll('.menu-drawer img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      }
      document.querySelectorAll('.header__icon--menu').forEach(function (b) {
        b.addEventListener('pointerdown', charger, { passive: true });
        b.addEventListener('mouseenter', charger, { passive: true });
        b.addEventListener('focus', charger, { passive: true });
      });
    }

    /* grilles de produits : l'attribut sizes prevoit 2 colonnes sur mobile (calc(50vw - 22px)) ; en vue « 1 colonne »
       on l'elargit pour que le navigateur charge une photo assez nette (et inversement au retour a 2 colonnes) */
    function imagesGrilleMobile() {
      var DEUX = 'calc(50vw - 22px)', UNE = 'calc(100vw - 32px)';
      function maj() {
        document.querySelectorAll('.product-grid').forEach(function (g) {
          var une = g.getAttribute('product-grid-view') === 'mobile-single';
          g.querySelectorAll('img[sizes*="vw - "]').forEach(function (img) {
            var s = img.getAttribute('sizes'), n = une ? s.replace(DEUX, UNE) : s.replace(UNE, DEUX);
            if (n !== s) img.setAttribute('sizes', n);
          });
        });
      }
      maj();
      document.querySelectorAll('results-list').forEach(function (liste) {
        var attente = false;
        new MutationObserver(function () {
          if (attente) return;
          attente = true;
          requestAnimationFrame(function () { attente = false; maj(); });
        }).observe(liste, { subtree: true, childList: true, attributes: true, attributeFilter: ['product-grid-view'] });
      });
    }

    /* barre de progression : au clic sur un lien interne vers une autre page (sauf si un script du theme a deja pris
       le clic en charge : tiroir panier, menu...) ; retiree des que la page s'affiche (ou au retour arriere) */
    function progression() {
      var barre = document.createElement('div');
      barre.className = 'mdb-progression';
      barre.setAttribute('aria-hidden', 'true');
      document.body.appendChild(barre);
      var minuterie;
      function fin() { document.documentElement.classList.remove('mdb-navigation'); }
      document.addEventListener('click', function (e) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest ? e.target.closest('a[href]') : null;
        if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
        var u;
        try { u = new URL(a.href, location.href); } catch (err) { return; }
        if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search)) return;
        setTimeout(function () {
          if (e.defaultPrevented) return;
          document.documentElement.classList.add('mdb-navigation');
          clearTimeout(minuterie);
          minuterie = setTimeout(fin, 8000);
        }, 0);
      });
      window.addEventListener('pageshow', fin);
    }

    /* en-tete « verre depoli » des que la page defile (le theme fait defiler .page-wrapper, pas la fenetre : on ecoute
       le defilement de tous les elements en phase de capture) */
    function enteteDefilement() {
      var html = document.documentElement, attente = false, pw = document.querySelector('.page-wrapper');
      function position() { return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0); }
      function maj() { attente = false; html.classList.toggle('mdb-defile', position() > 8); }
      document.addEventListener('scroll', function () { if (!attente) { attente = true; requestAnimationFrame(maj); } },
        { passive: true, capture: true });
      maj();
    }

    /* recherche : raccourci « / » (hors champ de saisie) + indice visuel sur le champ de l'en-tete (ordinateur) */
    function rechercheRapide() {
      function bouton() {
        return Array.prototype.find.call(document.querySelectorAll('#header-component search-button button'), function (b) { return b.offsetParent !== null; });
      }
      document.querySelectorAll('#header-component .header__column--right search-button button').forEach(function (b) {
        if (b.querySelector('.mdb-kbd')) return;
        var k = document.createElement('kbd');
        k.className = 'mdb-kbd'; k.textContent = '/'; k.setAttribute('aria-hidden', 'true');
        b.appendChild(k);
        b.setAttribute('aria-keyshortcuts', '/');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey || e.defaultPrevented) return;
        var t = e.target;
        if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
        if (document.querySelector('dialog[open]')) return;
        var b = bouton();
        if (!b) return;
        e.preventDefault();
        b.click();
      });
    }
    /* 07/10 : fiche produit : la photo s'incline legerement avec la souris (ordinateur), un reflet la suit */
    function galerie() {
      if (reduit || !window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
      var g = document.querySelector('media-gallery');
      if (!g) return;
      var cible = null, dernier = null, attente = false;
      function appliquer() {
        attente = false;
        if (!cible || !dernier) return;
        var r = cible.getBoundingClientRect(), x = (dernier.clientX - r.left) / r.width, y = (dernier.clientY - r.top) / r.height;
        cible.classList.add('mdb-suivi');
        cible.style.setProperty('--gry', ((x - 0.5) * 7).toFixed(2) + 'deg');
        cible.style.setProperty('--grx', ((0.5 - y) * 6).toFixed(2) + 'deg');
        cible.style.setProperty('--gmx', (x * 100).toFixed(1) + '%');
        cible.style.setProperty('--gmy', (y * 100).toFixed(1) + '%');
        cible.style.setProperty('--gl', '1');
      }
      function remettre(el) {
        if (!el) return;
        el.classList.remove('mdb-suivi');
        ['--gry', '--grx', '--gl'].forEach(function (v) { el.style.removeProperty(v); });
      }
      g.addEventListener('pointermove', function (ev) {
        if (ev.pointerType === 'touch') return;
        var c = ev.target.closest ? ev.target.closest('.product-media') : null;
        if (c !== cible) { remettre(cible); cible = c; }
        if (!c) return;
        dernier = ev;
        if (!attente) { attente = true; requestAnimationFrame(appliquer); }
      }, { passive: true });
      g.addEventListener('pointerleave', function () { remettre(cible); cible = null; });
    }

    /* 07/10 : defilement adouci a la molette (ordinateur, souris a crans seulement). Le defilement de la page est porte par .page-wrapper.
       Touchpad (petits deplacements), clavier, barre de defilement, tiroirs et zones defilantes imbriquees restent natifs. Desactivable : ?lisse=0 */
    function defilementDoux() {
      if (reduit || /[?&]lisse=0/.test(location.search) || !window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var w = document.querySelector('.page-wrapper');
      if (!w) return;
      var pos = 0, cible = 0, actif = false, t0 = 0;
      function aller(y) { try { w.scrollTo({ top: y, behavior: 'instant' }); } catch (e) { w.scrollTop = y; } }   /* « instant » : le CSS peut demander un defilement doux (scroll-behavior) qui ferait retarder la page sur notre mouvement */
      function defilable(el, dy) {
        for (var e = el; e && e !== w && e !== document.body; e = e.parentElement) {
          var s = getComputedStyle(e);
          if (/(auto|scroll)/.test(s.overflowY) && e.scrollHeight > e.clientHeight + 1 && ((dy < 0 && e.scrollTop > 0) || (dy > 0 && e.scrollTop + e.clientHeight < e.scrollHeight - 1))) return true;
        }
        return false;
      }
      function pas(t) {
        var dt = t0 ? Math.min(48, Math.max(1, t - t0)) : 16;
        t0 = t;
        if (Math.abs(w.scrollTop - pos) > 4) { actif = false; t0 = 0; return; }       /* la page a ete deplacee d'ailleurs (clavier, barre de defilement, lien) : on rend la main */
        var d = cible - pos;
        if (Math.abs(d) < 0.5) { pos = cible; aller(cible); actif = false; t0 = 0; return; }
        pos += d * (1 - Math.exp(-dt / 95));
        aller(pos);                                                                     /* « pos » reste un nombre a virgule : l'arrondi du navigateur ne doit pas bloquer la fin du mouvement */
        requestAnimationFrame(pas);
      }
      w.addEventListener('wheel', function (ev) {
        if (ev.ctrlKey || ev.defaultPrevented || Math.abs(ev.deltaX) > Math.abs(ev.deltaY)) return;
        if (ev.target.closest && ev.target.closest('dialog, [role="dialog"], cart-drawer-component, header-drawer, .menu-drawer, .quick-add-modal')) return;
        var dy = ev.deltaMode === 1 ? ev.deltaY * 40 : ev.deltaMode === 2 ? ev.deltaY * w.clientHeight : ev.deltaY;
        if (Math.abs(dy) < 40 || defilable(ev.target, dy)) return;                      /* touchpad / molette fine : deja doux ; zone imbriquee : native */
        ev.preventDefault();
        if (!actif) { pos = w.scrollTop; cible = pos; }
        cible = Math.max(0, Math.min(w.scrollHeight - w.clientHeight, cible + dy));
        if (!actif) { actif = true; t0 = 0; requestAnimationFrame(pas); }
      }, { passive: false });
    }

    /* 07/10 : etoiles filantes : chaque passage prend un point de depart, un angle, une longueur et une trajectoire au hasard (toujours de gauche a droite, vers le bas) */
    function etoilesFilantes() {
      if (reduit) return;
      var h = document.documentElement;
      function alea(a, b) { return a + Math.random() * (b - a); }
      function tirer(el, p) {
        var a = alea(16, 33), dx = alea(32, 54), W = window.innerWidth || 1280, H = window.innerHeight || 800;
        el.style.setProperty('--' + p + '-x', alea(2, 50).toFixed(1) + '%'.replace('%', el === h ? 'vw' : '%'));
        el.style.setProperty('--' + p + '-y', alea(3, 34).toFixed(1) + (el === h ? 'vh' : '%'));
        el.style.setProperty('--' + p + '-a', a.toFixed(1) + 'deg');
        el.style.setProperty('--' + p + '-l', Math.round(alea(120, 230)) + 'px');
        el.style.setProperty('--' + p + '-dx', dx.toFixed(1) + 'vw');
        el.style.setProperty('--' + p + '-dy', (dx * W / H * Math.tan(a * Math.PI / 180)).toFixed(1) + 'vh');
      }
      tirer(h, 'f1'); tirer(h, 'f2');
      document.addEventListener('animationiteration', function (ev) {
        if (ev.animationName !== 'mdb-filante' && ev.animationName !== 'mdb-filante-b') return;
        var t = ev.target;
        if (t === h) tirer(h, ev.pseudoElement === '::before' ? 'f1' : 'f2');
        else if (t.classList && t.classList.contains('mdb-ciel')) tirer(t, 'h');
      }, true);
    }

    function fluiditeAuto() {
      var h = document.documentElement;
      if (h.classList.contains('mdb-leger') || reduit) return;
      var dernier = 0, imgs = [], actif = false, t0 = 0, mauvais = 0, debut = performance.now();
      function passer() { h.classList.add('mdb-leger'); try { localStorage.setItem('mdb-leger', '1'); } catch (e) {} }
      function pas(t) {
        if (h.classList.contains('mdb-leger')) { actif = false; return; }
        var dt = t0 ? t - t0 : 16; t0 = t;
        if (t - dernier > 250) { actif = false; t0 = 0; imgs = []; return; }
        if (!document.hidden && t - debut > 2500) imgs.push(dt);
        if (imgs.length >= 40) {
          var lents = imgs.filter(function (v) { return v > 28; }).length;
          imgs = [];
          mauvais = lents / 40 > 0.1 ? mauvais + 1 : 0;
          if (mauvais >= 2) { passer(); actif = false; return; }
        }
        requestAnimationFrame(pas);
      }
      document.addEventListener('scroll', function () {
        dernier = performance.now();
        if (!actif) { actif = true; t0 = 0; requestAnimationFrame(pas); }
      }, { capture: true, passive: true });
    }

    function init() { sectionsDescription(); recommandations(); livraison(); animations(); inclinaison(); galerie(); defilementDoux(); etoilesFilantes(); fluiditeAuto(); prechargementMenu(); imagesGrilleMobile(); progression(); enteteDefilement(); suiveurMenu(); rechercheRapide(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
